import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

export const doctorValidation = Yup.object({
  firstName: createValidationRule("string").required("First name is required"),
  lastName: createValidationRule("string").required("Last name is required"),
  email: createValidationRule("email").required("Email is required"),
  phoneNumber: createValidationRule("phone").required(
    "Phone number is required"
  ),
  experience: createValidationRule("number").required("Experience is required"),
  speciality: Yup.string().required("Speciality is required"),
  qualification: Yup.string().required("Qualification is required"),
  consultationFee: createValidationRule("number").required(
    "Consultation fee is required"
  ),
});
